export const generateCodeVerifier = (): string =>
  Array.from(Array(70), () => Math.floor(Math.random() * 36).toString(36)).join('');
